<template>
  <div>
    <CardList/>
    <Transactions/>
  </div>
</template>

<script>
import CardList from './features/CardList'
import Transactions from "./features/Transactions";

export default {
  components: {
    CardList,
    Transactions
  }
}
</script>



// WEBPACK FOOTER //
// src/components/payment/index.vue